var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
import { Component, Vue, Model } from 'vue-property-decorator';
import ErrorHandler from '@/support/ErrorHandler';
import { Group } from '@/models/Group';
import { RolesEnum } from '@/items/Roles';
import AQuillEditor from '@/components/AQuillEditor/AQuillEditor.vue';
let Notes = class Notes extends Vue {
    constructor() {
        super(...arguments);
        this.content = '';
        this.editorOptions = {
            modules: {
                toolbar: this.$store.state.Auth.hasRole([
                    RolesEnum.TEACHER,
                    RolesEnum.ADMIN,
                    RolesEnum.ROOT,
                    RolesEnum.TRAINER,
                    RolesEnum.MANAGER,
                ])
                    ? true
                    : false,
            },
        };
    }
    mounted() {
        this.content = this.group.notes || '';
    }
    save() {
        this.group
            .include(['audit', 'chat', 'users', 'subjects', 'roles', 'parent'])
            .update({ notes: this.content })
            .then(() => {
            this.group.notes = this.content;
            this.$emit('update', this.group);
            this.$store.dispatch('openDialog', this.dialogOptions);
        })
            .catch((error) => {
            ErrorHandler.network(error);
        });
    }
    get dialogOptions() {
        return {
            title: this.$tc('dialogOptions.confirmation'),
            text: this.$tc('dialogOptions.save', 0, { item: this.$tc('dialogOptions.item.note') }),
            type: 'success',
            buttons: {
                confirm: {
                    text: this.$tc('dialogOptions.button.ok'),
                },
            },
        };
    }
    get isAuthorized() {
        return this.$store.state.Auth.hasRole([
            RolesEnum.ADMIN,
            RolesEnum.ROOT,
            RolesEnum.TRAINER,
            RolesEnum.MANAGER,
            RolesEnum.TEACHER,
        ]);
    }
};
__decorate([
    Model('group'),
    __metadata("design:type", typeof (_a = typeof Group !== "undefined" && Group) === "function" ? _a : Object)
], Notes.prototype, "group", void 0);
Notes = __decorate([
    Component({
        components: {
            AQuillEditor,
        },
    })
], Notes);
export default Notes;
